import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { apiClient, provisioningPath } from '@/lib/api-client';

import { provisioningKeys } from './provisioning-keys';

/**
 * POST /api/admin/provisioning/tasks/:id/stop — stops a running task.
 * Admin-only on the backend; the UI gates the button by role too.
 */
export function useStopTask(): UseMutationResult<{ stopped: boolean }, Error, number> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (taskId: number) =>
      apiClient.post<{ stopped: boolean }>(provisioningPath(`/tasks/${taskId}/stop`)),
    onSuccess: (_data, taskId) => {
      void queryClient.invalidateQueries({ queryKey: provisioningKeys.task(taskId) });
    },
  });
}
